<template>
	<div class="ui-modal__wrapper mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-ready"
       :class="{ [extraClass]: true }"
       tabindex="-1" style="overflow: hidden auto;"
       @keyup.esc="$emit('close', false)">
		<div class="mfp-container mfp-s-ready mfp-inline-holder">
			<div class="mfp-content">
				<div id="popup-info" class="simple-popup magic-popup">
          <div class="popup-header">
            <slot name="header"></slot>
          </div>
					<div class="popup-content">
						<h3>{{ title }}</h3>
						<div>
							<div class="popup-scroller">
								<p><slot></slot></p>
							</div>
							<div class="popup-actions">
								<slot name="buttons"><button type="button" class="white-button mfp-close" @click="$emit('close', true)">OK</button></slot>
							</div>

							<div v-if="$slots['footer']" class="popup-footer">
								<slot name="footer"></slot>
							</div>
						</div>
					</div>
					<button title="Fermer (Esc)" type="button" class="mfp-close" @click="$emit('close', false)" v-if="closable">×</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  props: {
    title: String,
    extraClass: String,
    closable: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.ui-modal {
	&__wrapper {
		background: rgba(0, 0, 0, 0.5);
		z-index: 10000;

		.popup-actions {
			display: flex;
			justify-content: space-around;
		}

    .simple-popup#popup-info .mfp-close.white-button:disabled {
      opacity: 0.5;
    }
		.simple-popup#popup-info .mfp-close.white-button:hover:enabled {
			color: #FFF !important;
			background: $red !important;
		}

    @media #{$phone} {
			.simple-popup {
				padding: 16px !important;
      }
			.white-button {
				min-width: 100px !important;
			}
		}

		.popup-content .popup-footer, .popup-content .popup-footer * {
			color: #707070;
			font-style: italic;
			margin-top: 25px;
			font-size: 11px;
		}

    .popup-header {
      color: #707070;
      text-align: center;
    }

		h3 {
			color: $red;
			text-align: center;
		}
	}
}
</style>
